/**
 * CompareHelpLine — renders the live compareHelp output: the plain-English
 * meaning plus the worked example, a self-compare warning, or the fill-in
 * prompt. Shared by the Rules-tab row and the tag-rule compare editor so the
 * two surfaces can never phrase the same condition differently.
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import { AlertTriangle } from 'lucide-react';

import { cn } from '@/lib/utils';

import type { CompareHelp } from './compare-sentence';

export const CompareHelpLine: FC<{ help: CompareHelp; className?: string }> = ({
  help,
  className,
}) => {
  if (help.kind === 'warning') {
    return (
      <span
        className={cn(
          'flex items-start gap-1.5 text-[11px] leading-snug text-amber-700 dark:text-amber-400',
          className,
        )}
      >
        <AlertTriangle className="mt-0.5 h-3 w-3 shrink-0" aria-hidden />
        <span>{help.text}</span>
      </span>
    );
  }
  if (help.kind === 'prompt') {
    return (
      <span className={cn('text-[11px] leading-snug text-muted-foreground', className)}>
        {help.text}
      </span>
    );
  }
  return (
    <span className={cn('text-[11px] leading-snug text-muted-foreground', className)}>
      <span className="font-medium text-foreground/80">{help.summary}</span>{' '}
      <span>{help.example}</span>
    </span>
  );
};

export default CompareHelpLine;
